module.exports = __webpack_public_path__ + "static/img/house1-thumb.72ed738.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/house1-thumb.jpg
// module id = p3Ys
// module chunks = 0